export const RERENDER_MUST_READ_COMPONENT_BUS_NAME =
  'RERENDER_MUST_READ_COMPONENT_BUS_NAME'
